// Finance build — React Query hooks for the staff Income Overview surface and
// its per-loan events drill. Read-only; query keys come from the co-located
// incomeOverviewKeys factory.

import { useQuery } from "@tanstack/react-query";
import {
  incomeOverviewApi,
  type IncomeOverviewParams,
} from "@/api/portfolioAdmin/incomeOverviewApi";
import { incomeOverviewKeys } from "./incomeOverviewKeys";

export function useIncomeOverview(params: IncomeOverviewParams) {
  return useQuery({
    queryKey: incomeOverviewKeys.overview(params),
    queryFn: () => incomeOverviewApi.get(params),
  });
}

export function useLoanIncomeEvents(
  loanId: string | undefined,
  params: IncomeOverviewParams,
) {
  return useQuery({
    queryKey: incomeOverviewKeys.loanEvents(loanId ?? "", params),
    queryFn: () => incomeOverviewApi.events(loanId!, params),
    enabled: !!loanId,
  });
}
